import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { CircleNotch, Lightning } from "@phosphor-icons/react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    // useRef guard to avoid double-processing under React StrictMode
    if (processed.current) return;
    processed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const params = new URLSearchParams(hash.replace(/^#/, ""));
      const sessionId = params.get("session_id");
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const res = await api.post(
          "/auth/session",
          {},
          {
            headers: { "X-Session-ID": sessionId },
            withCredentials: true,
          }
        );
        setUser(res.data);
        // Clean the URL and go to dashboard
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true, state: { user: res.data } });
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/login", { replace: true, state: { error: "Login failed. Please try again." } });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-arena-bg text-arena-text font-mono flex items-center justify-center">
      <div className="text-center">
        <Lightning size={32} weight="fill" className="text-arena-primary mx-auto mb-3 animate-pulse" />
        <div className="flex items-center justify-center gap-2 text-arena-primary">
          <CircleNotch size={16} weight="bold" className="animate-spin" />
          <span className="text-xs tracking-widest uppercase">Authenticating...</span>
        </div>
      </div>
    </div>
  );
}
